export default __webpack_public_path__ + "static/media/dream_of_the_dandelion_gladiator.dce2ce9f.png";